module.exports = __webpack_public_path__ + "img/home_new_4.68ec1f9a.jpg";